import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/Order/Order.requests'
import simpleApi from 'app/services/simpleApi'

const useUpdateStatusOrder = (onSuccess: () => void) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessModification,
        onError,
    } = useHandleStatusRequest({
        id: 'OrderByNumberView',
        title: 'Order Status Updated',
        onSuccess,
    })

    return useMutation({
        mutationFn: (orderNumber: string) => {
            return simpleApi({
                ...requests.confirmStatus({
                    orderNumber,
                }),
                token,
            })
        },
        onSuccess: onSuccessModification,
        onError,
    })
}

export default useUpdateStatusOrder
